import React from 'react';
import { observer } from 'mobx-react-lite';
import { Box, Divider, Grid, Typography } from '@mui/material';
import DesktopWindowsTwoToneIcon from '@mui/icons-material/DesktopWindowsTwoTone';
import ScheduleTwoToneIcon from '@mui/icons-material/ScheduleTwoTone';
import MopedTwoToneIcon from '@mui/icons-material/MopedTwoTone';
import Restaurant from '@components/restaurant/models/Restaurant';

interface RestaurantStatusProps {
    restaurant: Restaurant;
}

const RestaurantStatus: React.FC<RestaurantStatusProps> = observer(({ restaurant }) => {
    return (
        <Box mt={1} display={"flex"} flexDirection={"row"} gap={0.5}>
            <DesktopWindowsTwoToneIcon sx={{ fontSize: 16 }} color={restaurant.isOnline ? 'success' : 'disabled'} />
            <Typography mr={0.5} variant='caption' color={"GrayText"}>{restaurant.isOnline ? 'Na mreži' : 'Izvan mreže'}</Typography>
            <Divider orientation="vertical" flexItem />

            <ScheduleTwoToneIcon sx={{ fontSize: 16 }} color={restaurant.isOpenTimeActive ? 'primary' : 'disabled'} />
            <Typography mr={0.5} variant='caption' color={"GrayText"}>
                {`${restaurant.openingTime.substr(0, 5)}-${restaurant.closingTime.substr(0, 5)}`}
            </Typography>
            <Divider orientation="vertical" flexItem />
            {restaurant.hasDelivery && (
            <>
                <MopedTwoToneIcon sx={{ fontSize: 16 }} color={restaurant.isDeliveryActive ? 'primary' : 'disabled'} />
                <Typography variant='caption' color={"GrayText"}>
                    {`${restaurant.deliveryTimeFrom?.substr(0, 5)}-${restaurant.deliveryTimeTo?.substr(0, 5)}`}
                </Typography>
            </>
)}
        </Box>
    )
})

export default RestaurantStatus;